// Mapeo de la salud de ruta (GRS) a color/etiqueta para los badges de la UI.
// Fuente del nivel: pt_service_billing.route_health_level ∈
// critical | low | moderate | good | excellent (score 0..100). Reutilizado por
// la lista, el kanban y el detalle para que el indicador sea consistente.

const COLOR_BY_LEVEL = {
  excellent: "success",
  good: "info",
  moderate: "warning",
  low: "danger",
  critical: "danger",
}

const LABEL_KEY_BY_LEVEL = {
  excellent: "RouteHealthExcellent",
  good: "RouteHealthGood",
  moderate: "RouteHealthModerate",
  low: "RouteHealthLow",
  critical: "RouteHealthCritical",
}

const FALLBACK_LABEL_ES = {
  excellent: "Excelente",
  good: "Buena",
  moderate: "Moderada",
  low: "Baja",
  critical: "Crítica",
}

// Niveles de salud ordenados de mejor a peor, para poblar selects de filtro.
// Devuelve [{ value, label }] usando i18n si se pasa `t`, con fallback ES.
export const ROUTE_HEALTH_LEVELS = ["excellent", "good", "moderate", "low", "critical"]

export const routeHealthLevelOptions = (t) => {
  const translate = typeof t === "function" ? t : (k) => k
  return ROUTE_HEALTH_LEVELS.map((level) => ({
    value: level,
    label: (LABEL_KEY_BY_LEVEL[level] && translate(LABEL_KEY_BY_LEVEL[level]))
      || FALLBACK_LABEL_ES[level]
      || level,
  }))
}

// Devuelve { color, label, level, score } para un nivel/score dados.
// `t` es la función i18n (opcional); si no se pasa, usa etiquetas en español.
export const routeHealthMeta = (level, score, t) => {
  const translate = typeof t === "function" ? t : (k) => k
  if (!level) {
    return {
      color: "secondary",
      label: translate("RouteHealthUnknown") || "Sin datos",
      level: null,
      score: score ?? null,
    }
  }
  const color = COLOR_BY_LEVEL[level] || "secondary"
  const key = LABEL_KEY_BY_LEVEL[level]
  const label = (key && translate(key)) || FALLBACK_LABEL_ES[level] || level
  return { color, label, level, score: score ?? null }
}

export default routeHealthMeta
